export default {
  1: 'Hate it',
  2: 'Dislike it',
  3: 'It’s OK',
  4: 'Like it',
  5: 'Love it'
};